import React from 'react';
import Icon from '@/v2/components/atoms/Icon';

import './Navigate.scss';

const Navigate = (props) => (
    <Icon iconName="Navigate" {...props}>
        <svg viewBox="0 0 43 43" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-591.000000, -850.000000)">
                    <g transform="translate(591.000000, 850.000000)">
                        <path
                            // eslint-disable-next-line
                            d="M41.8839,21.3171 C41.8839,32.6751 32.6759,41.8831 21.3169,41.8831 C9.9579,41.8831 0.7499,32.6751 0.7499,21.3171 C0.7499,9.9581 9.9579,0.7501 21.3169,0.7501 C32.6759,0.7501 41.8839,9.9581 41.8839,21.3171 Z"
                            stroke="#FFFFFF"
                            strokeWidth="1.5"
                            fillOpacity="0.4"
                            fill="#020A0D"
                        />
                        <path
                            // eslint-disable-next-line
                            d="M12.9684,30.5085 L18.1744,19.1215 C18.2544,18.9455 18.3824,18.7895 18.5374,18.6765 L28.6544,11.2995 C29.3294,10.8065 30.0134,11.3645 29.6654,12.1245 L24.4594,23.5125 C24.3794,23.6875 24.2514,23.8435 24.0954,23.9565 L13.9794,31.3345 C13.3034,31.8265 12.6204,31.2695 12.9684,30.5085 Z"
                            stroke="#FFFFFF"
                            strokeWidth="1.5"
                        />
                        <path
                            // eslint-disable-next-line
                            d="M22.5997,21.491 C22.5997,22.2 22.0257,22.774 21.3167,22.774 C20.6087,22.774 20.0347,22.2 20.0347,21.491 C20.0347,20.783 20.6087,20.209 21.3167,20.209 C22.0257,20.209 22.5997,20.783 22.5997,21.491"
                            fill="#FFFFFF"
                        />
                    </g>
                </g>
            </g>
        </svg>
    </Icon>
);

export default Navigate;
